module.exports = __webpack_public_path__ + "img/cg_corpse.091e0b6f.jpg";